import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.css']
})
export class GameComponent implements OnInit {

  percentFinished = 0;
  currentQuestion = 0;
  currentRotation = _.random(0, 360);
  score = 0;

  diamonds = [
    {
      url: '2_btd_5.png',
      name: 'Better than Diamond Eternity ($650/ct)'
    },
    // {
    //   url: '2_c_c_6.png',
    //   name: 'Charles and Colvard'
    // },
    {
      url: '2_real_8.png',
      name: 'GIA Certified Natural Diamond ($5800/ct)'
    },
    // {
    //   url: '2_c_c_2.png',
    //   name: 'Charles and Colvard'
    // },
    {
      url: '2_real_7.png',
      name: 'GIA Certified Natural Diamond ($5800/ct)'
    },
    {
      url: '2_lab_1.png',
      name: 'Chatham Lab-Grown Diamond ($4800/ct)'
    },
    {
      url: '2_c_c_h_1.png',
      name: 'Charles and Colvard - hearts and arrows ($659/ct)'
    },
    {
      url: '2_real_7.png',
      name: 'GIA Certified Natural Diamond ($5800/ct)'
    },
    {
      url: '2_lab_6.png',
      name: 'Chatham Lab-Grown Diamond ($4800/ct)'
    },
    {
      url: '2_c_c_h_8.png',
      name: 'Charles and Colvard - hearts and arrows ($659/ct)'
    },
    {
      url: '2_c_c_h_9.png',
      name: 'Charles and Colvard - hearts and arrows ($659/ct)'
    },
    {
      url: '2_lab_4.png',
      name: 'Chatham Lab-Grown Diamond ($4800/ct)'
    },
    {
      url: '2_btd_10.png',
      name: 'Better than Diamond Eternity ($650/ct)'
    },
    {
      url: '2_lab_4.png',
      name: 'Chatham Lab-Grown Diamond ($4800/ct)'
    },
    {
      url: '2_neo_9.png',
      name: 'NEO Diamond Cut ($325/ct)'
    },
    {
      url: '2_real_5.png',
      name: 'GIA Certified Natural Diamond ($5800/ct)'
    },
    {
      url: '2_neo_10.png',
      name: 'NEO Diamond Cut ($325/ct)'
    },
    {
      url: '2_real_7.png',
      name: 'GIA Certified Natural Diamond ($5800/ct)'
    },
    // {
    //   url: '2_real_8.png',
    //   name: 'GIA Certified Natural Diamond'
    // },
    {
      url: '2_lab_6.png',
      name: 'Chatham Lab-Grown Diamond ($4800/ct)'
    },
  ]
  quiz = [];
  generating = true;
  repoUrl = 'http://www.isitdiamond.com'

  constructor() { }

  checkAnswer(hasClicked, questionNum) {
    this.quiz[questionNum].clicked = hasClicked;
    const isDiamond1 = _.includes(this.quiz[questionNum].url, 'real')
    const isDiamond2 = _.includes(this.quiz[questionNum].url, 'lab')
    if ((hasClicked === true && (isDiamond1 || isDiamond2))) {
      this.quiz[questionNum].correct = hasClicked;
    } else if ((hasClicked === false && (isDiamond1 || isDiamond2))) {
      this.quiz[questionNum].correct = hasClicked;
    } else if (hasClicked === true) {
      this.quiz[questionNum].correct = false
    } else if (hasClicked === false) {
      this.quiz[questionNum].correct = true;
    }
    this.percentFinished = this.percentFinished += 10
    if (questionNum === 9) {
      this.generating = true;
      console.log('finished')
      this.generateGrade()
      console.log(this.quiz)
    } else {
      this.currentRotation = _.random(0, 360);
      this.currentQuestion = this.currentQuestion += 1
    }
  }

  generateGrade() {
    this.score = this.quiz.filter(a => a.correct === false).length;
    this.generating = false;
    this.currentQuestion = 10;
  }

  generateArray() {
    let questions = [];
    for(var i = 0; i < 10; i++){
      questions[i]=this.diamonds[_.random(0, 16)]
      if (i >= 1) {
        while (questions[i-1].name === questions[i].name) {
          questions[i]=this.diamonds[_.random(0, 16)]
        }
      }
    }
    this.quiz = questions;
    let hasDiamond = this.quiz.find(o => { return o.url.includes('real') })
    let hasLab = this.quiz.find(o => { return o.url.includes('lab') })
    //let hasCC = this.quiz.find(o => { return o.url.includes('c_c') })
    let hasCCHearts = this.quiz.find(o => { return o.url.includes('c_c_h' ) })
    let hasBTD = this.quiz.find(o => { return o.url.includes('btd' ) })
    let hasNeo = this.quiz.find(o => { return o.url.includes('neo' ) })
    if (!hasDiamond || !hasLab|| !hasCCHearts || !hasBTD || !hasNeo) {
      this.generateArray()
    } else {
      this.generating = false;
    }
    console.log(this.quiz)
  }

  ngOnInit() {
    this.generateArray();
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/game/game.component.ts